export const κ = 24389 / 27; // 29^3/3^3
export const ε = 216 / 24389; // 6^3/29^3
export const white = [0.96422, 1.0, 0.82521]; // D50 reference white
